import React from 'react';
import { useMutation } from '@tanstack/react-query';
import services from 'services/services';

/** @typedef {import('services/services').EnableDoubleOptInResponseData} EnableDoubleOptInResponseData */

/** @typedef {Omit<import('@tanstack/react-query').UseMutationOptions<EnableDoubleOptInResponseData, Error, unknown, unknown>, 'mutationKey' | 'mutationFn'>} UseEnableDoubleOptInMutationOptions */

/**
 * Enable double opt-in by changing account setting.
 *
 * @param {UseEnableDoubleOptInMutationOptions} [options={}]
 */
export const useEnableDoubleOptInMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['enable-double-opt-in'],
        mutationFn: () => services.enableDoubleOptIn()
    });
};
